import { render } from "./filterIcons.vue?vue&type=template&id=3869c6f8"
import script from "./filterIcons.vue?vue&type=script&lang=js"
export * from "./filterIcons.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\Merlin.Website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__